var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.loggedIn)?_c('DefaultLayoutSidebar',{attrs:{"clipped":_vm.clipped,"bottom-items":_vm.sidebarBottomItems,"top-items":_vm.sidebarTopItems,"language-switcher-props":_vm.sidebarLanguageSwitcherProps,"sidebar-logo-props":_vm.sidebarLogoProps,"loggedIn":_vm.loggedIn}}):_vm._e(),_c('v-main',{class:[
      _vm.loggedInUser ? 'sideBarStyle' : '',
      !_vm.loggedInUser ? 'noSideBarStyle' : '',
      'pt-0',
    ]},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }